import { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

export class Modal extends Component {
  /* eslint-disable-next-line react/sort-comp */
  static propTypes = {
    children: PropTypes.node,
  };

  el = document.createElement('div');

  componentDidMount() {
    // The portal element is inserted in the DOM tree after
    // the Modal's children are mounted, meaning that children
    // will be mounted on a detached DOM node. If a child
    // component requires to be attached to the DOM tree
    // immediately when mounted, for example to measure a
    // DOM node, or uses 'autoFocus' in a descendant, add
    // state to Modal and only render the children when Modal
    // is inserted in the DOM tree.
    document.body.appendChild(this.el);
  }

  componentWillUnmount() {
    (this.el.parentNode as any).removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}
